import { render, staticRenderFns } from "./ConfigurationTaxesCard.vue?vue&type=template&id=3a25247a&scoped=true&"
import script from "./ConfigurationTaxesCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTaxesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25247a",
  null
  
)

export default component.exports